/**
 * The side-panel toggle's glyph: a panel with its side column marked.
 *
 * It is the shape the owner pointed at on 17 September 2026 for the navigation's collapse control —
 * the sidebar glyph a reader already knows from every editor and browser that has one — and it
 * stays the same drawing in both states rather than flipping into an arrow: the button says which
 * way it will go through `aria-expanded` and its own name, and a glyph that also claimed a
 * direction would be a second, silent source for that fact.
 *
 * Moved here from `app/ui/NavIcons.tsx` on its second consumer, the AI Buddy module's history
 * toggle (10 October 2026): a page may not import from `app/`, and a second drawing of the same
 * box would drift from the first.
 *
 * Drawn at `stroke-width: 1.6`, a step quieter than the navigation's destinations, because it is a
 * control rather than a destination. The caller states the size through `className`.
 */
export function SidebarIcon({ className }: { readonly className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <rect x="3" y="4.5" width="18" height="15" rx="3.5" />
      <path d="M9.5 4.5v15" />
    </svg>
  );
}
